<template>  
    <el-container id="helpDetail">
            <!-- 头部 -->
        <el-main>
             <transition name="slide"><router-view /></transition>
        </el-main>
    </el-container>
</template>
<script>
 import enHeader from "./components/enterpriseHeader.vue"
    export default {
        name: "helpDetail",
        components: {
            enHeader
        },
        created() {
        },
        mounted() {},
        computed: {
        },

        watch: {},
        methods: {}
    }
</script>
<style lang="scss" scoped>
#helpDetail{
    width: 100%;
    height: 100vh;
    .indeherader{
    height: 80px;
     background: #323232;
    width: 100%;
    .nsherader{
        width: 100%;
        margin: 0 auto;
        height: inherit !important;
    }
}
}
</style>
